module.exports = __webpack_public_path__ + "img/galerie-50.a9449f31.jpg";